import {
  IBalanceRequest,
  IBalanceFieldGroups,
  BalanceCompositionValueType,
  BalanceCompositionKeyType,
  BalanceResultProductType,
} from "@/core/models/balance.model";

export const BALANCE_FIELD_GROUPS: IBalanceFieldGroups = {
  natural_gas: [
    {
      title: "PNG (413)",
      width: 6,
      fields: [
        {
          key: "tng_burn_1",
          title: "Temperature (°C)",
          min: 25,
          max: 35,
        },
        {
          key: "png_2",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 20128,
          max: 22986,
        },
      ],
    },
    {
      title: "Preheated NG (417)",
      width: 6,
      fields: [
        {
          key: "tng_preheat_3",
          title: "Temperature (°C)",
          min: 342,
          max: 356,
        },
        {
          key: "png_2",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 20128,
          max: 22986,
          readonly: true,
        },
      ],
    },
    {
      title: "Main Burner NG (422)",
      width: 6,
      fields: [
        {
          key: "main_ng_6",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 0,
          max: 5000,
        },
      ],
    },
    {
      title: "Aux Burner NG (410)",
      width: 6,
      fields: [
        {
          key: "aux_ng_8",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 400,
          max: 2700,
        },
      ],
    },
    {
      title: "Enrichment NG (428)",
      width: 4,
      fields: [
        {
          key: "enr_9",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 1991,
          max: 4000,
        },
      ],
    },
    {
      title: "Transition NG (434)",
      width: 4,
      fields: [
        {
          key: "ngtr_10",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 1400,
          max: 4000,
        },
      ],
    },
    {
      title: "China hat NG (436)",
      width: 4,
      fields: [
        {
          key: "ngch_11",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 800,
          max: 2000,
        },
      ],
    },
    {
      title: "Natural Gas (413)",
      width: 12,
      checkSetionTotal: true,
      fields: [
        {
          key: "c_png_0_13",
          title: "CO (%)",
        },
        {
          key: "c_png_1_13",
          title: "CO\u2082 (%)",
        },
        {
          key: "c_png_2_13",
          title: "H\u2082 (%)",
        },
        {
          key: "c_png_3_13",
          title: "H\u2082O (%)",
        },
        {
          key: "c_png_4_13",
          title: "N\u2082 (%)",
        },
        {
          key: "c_png_5_13",
          title: "CH\u2084 (%)",
        },
        {
          key: "c_png_6_13",
          title: "C\u2082H\u2086 (%)",
        },
        {
          key: "c_png_7_13",
          title: "C\u2083H\u2088 (%)",
        },
        {
          key: "c_png_8_13",
          title: "C\u2084H\u2081\u2080 (%)",
        },
        {
          key: "c_png_9_13",
          title: "C\u2085H\u2081\u2082 (%)",
        },
        {
          key: "c_png_10_13",
          title: "C\u2086H\u2081\u2084 (%)",
        },
        {
          key: "c_png_11_13",
          title: "O\u2082 (%)",
        },
      ],
    },
    {
      title: "Bustle Gas (152)",
      width: 12,
      checkSetionTotal: true,
      fields: [
        {
          key: "cdbus_0_200",
          title: "CO (%)",
        },
        {
          key: "cdbus_1_200",
          title: "CO\u2082 (%)",
        },
        {
          key: "cdbus_2_200",
          title: "H\u2082 (%)",
        },
        {
          key: "cdbus_3_200",
          title: "H\u2082O (%)",
          readonly: true,
        },
        {
          key: "cdbus_4_200",
          title: "N\u2082 (%)",
        },
        {
          key: "cdbus_5_200",
          title: "CH\u2084 (%)",
        },
        {
          key: "cdbus_6_200",
          title: "C\u2082H\u2086 (%)",
        },
        {
          key: "cdbus_7_200",
          title: "C\u2083H\u2088 (%)",
        },
        {
          key: "cdbus_8_200",
          title: "C\u2084H\u2081\u2080 (%)",
        },
        {
          key: "cdbus_9_200",
          title: "C\u2085H\u2081\u2082 (%)",
        },
        {
          key: "cdbus_10_200",
          title: "C\u2086H\u2081\u2084 (%)",
        },
        {
          key: "cdbus_11_200",
          title: "O\u2082 (%)",
        },
      ],
    },
  ],
  air_flows: [
    {
      title: "Main Combustion Air to 1st stage Bundle (514)",
      width: 6,
      fields: [
        {
          key: "t_air_in_25",
          title: "Temperature (°C)",
          min: 53,
          max: 64,
        },
        {
          key: "comb_air_26",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 137700,
          max: 157249,
        },
      ],
    },
    {
      title: "Main Combustion Air to 2nd stage Bundle (516)",
      width: 6,
      fields: [
        {
          key: "t_air_cold_27",
          title: "Temperature (°C)",
          min: 295,
          max: 320,
        },
        {
          key: "comb_air_26",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 137700,
          max: 157249,
          readonly: true,
        },
      ],
    },
    {
      title: "Main Combustion Air to Burner (519)",
      width: 6,
      fields: [
        {
          key: "t_air_hot_29",
          title: "Temperature (°C)",
          min: 650,
          max: 670,
        },
        {
          key: "comb_air_26",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 137700,
          max: 157249,
          readonly: true,
        },
      ],
    },
    {
      title: "Air to Aux Burner (524)",
      width: 6,
      fields: [
        {
          key: "t_air_aux_31",
          title: "Temperature (°C)",
          min: 49,
          max: 60,
        },
        {
          key: "aux_air_32",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 4080,
          max: 22000,
        },
      ],
    },
    {
      title: "Dilution Air to Flue Gas mixer (545)",
      width: 6,
      fields: [
        {
          key: "t_dil_air_33",
          title: "Temperature (°C)",
          min: 40,
          max: 50,
        },
        {
          key: "dil_air_34",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 0,
          max: 25000,
        },
      ],
    },
    {
      title: "Air Humidity (545)",
      width: 6,
      fields: [
        {
          key: "wair_35",
          title: "H\u2082O (%)",
        },
      ],
    },
  ],
  process_flows: [
    {
      title: "Top Gas Fuel (261)",
      width: 8,
      fields: [
        {
          key: "t_tgf_36",
          title: "Temperature (°C)",
          min: 38,
          max: 50,
        },
        {
          key: "tgf_37",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 60259,
          max: 68814,
        },
        {
          key: "p_tgf_38",
          title: "Pressure (Barg)",
          min: 0.5,
          max: 0.588,
        },
      ],
    },
    {
      title: "Cooling Gas to Reformed Gas (218)",
      width: 4,
      fields: [
        {
          key: "c_zrg_106",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 3000,
          max: 3426,
        },
      ],
    },
    {
      title: "Process Gas to PG mixer (131)",
      width: 12,
      checkSetionTotal: true,
      fields: [
        {
          key: "tpg_51",
          title: "Temperature (°C)",
          min: 70,
          max: 90,
        },
        {
          key: "pg_52",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 98490,
          max: 112472,
        },
        {
          key: "p_pg_53",
          title: "Pressure (Barg)",
          min: 2.14,
          max: 2.55,
        },
        {
          key: "cd_pg_0_54",
          title: "CO (%)",
        },
        {
          key: "cd_pg_1_54",
          title: "CO\u2082 (%)",
        },
        {
          key: "cd_pg_2_54",
          title: "H\u2082 (%)",
        },
        {
          key: "cd_pg_3_54",
          title: "H\u2082O (%)",
          readonly: true,
        },
        {
          key: "cd_pg_4_54",
          title: "N\u2082 (%)",
        },
        {
          key: "cd_pg_5_54",
          title: "CH\u2084 (%)",
        },
        {
          key: "cd_pg_6_54",
          title: "C\u2082H\u2086 (%)",
        },
        {
          key: "cd_pg_7_54",
          title: "C\u2083H\u2088 (%)",
        },
        {
          key: "cd_pg_8_54",
          title: "C\u2084H\u2081\u2080 (%)",
        },
        {
          key: "cd_pg_9_54",
          title: "C\u2085H\u2081\u2082 (%)",
        },
        {
          key: "cd_pg_10_54",
          title: "C\u2086H\u2081\u2084 (%)",
        },
        {
          key: "cd_pg_11_54",
          title: "O\u2082 (%)",
        },
      ],
    },
    {
      title: "Reformed Gas (151)",
      width: 12,
      checkSetionTotal: true,
      fields: [
        {
          key: "t_rg_66",
          title: "Temperature (°C)",
          min: 910,
          max: 980,
        },
        {
          key: "cd_rg_0_68",
          title: "CO (%)",
        },
        {
          key: "cd_rg_1_68",
          title: "CO\u2082 (%)",
        },
        {
          key: "cd_rg_2_68",
          title: "H\u2082 (%)",
        },
        {
          key: "cd_rg_3_68",
          title: "H\u2082O (%)",
          readonly: true,
        },
        {
          key: "cd_rg_4_68",
          title: "N\u2082 (%)",
        },
        {
          key: "cd_rg_5_68",
          title: "CH\u2084 (%)",
        },
        {
          key: "cd_rg_6_68",
          title: "C\u2082H\u2086 (%)",
        },
        {
          key: "cd_rg_7_68",
          title: "C\u2083H\u2088 (%)",
        },
        {
          key: "cd_rg_8_68",
          title: "C\u2084H\u2081\u2080 (%)",
        },
        {
          key: "cd_rg_9_68",
          title: "C\u2085H\u2081\u2082 (%)",
        },
        {
          key: "cd_rg_10_68",
          title: "C\u2086H\u2081\u2084 (%)",
        },
        {
          key: "cd_rg_11_68",
          title: "O\u2082 (%)",
        },
      ],
    },
    {
      title: "Cooling Gas Offtake (205)",
      width: 12,
      checkSetionTotal: true,
      fields: [
        {
          key: "cgo_80",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 74300,
          max: 84848,
        },
        {
          key: "c_cgo_0_81",
          title: "CO (%)",
        },
        {
          key: "c_cgo_1_81",
          title: "CO\u2082 (%)",
        },
        {
          key: "c_cgo_2_81",
          title: "H\u2082 (%)",
        },
        {
          key: "c_cgo_3_81",
          title: "H\u2082O (%)",
        },
        {
          key: "c_cgo_4_81",
          title: "N\u2082 (%)",
        },
        {
          key: "c_cgo_5_81",
          title: "CH\u2084 (%)",
        },
        {
          key: "c_cgo_6_81",
          title: "C\u2082H\u2086 (%)",
        },
        {
          key: "c_cgo_7_81",
          title: "C\u2083H\u2088 (%)",
        },
        {
          key: "c_cgo_8_81",
          title: "C\u2084H\u2081\u2080 (%)",
        },
        {
          key: "c_cgo_9_81",
          title: "C\u2085H\u2081\u2082 (%)",
        },
        {
          key: "c_cgo_10_81",
          title: "C\u2086H\u2081\u2084 (%)",
        },
        {
          key: "c_cgo_11_81",
          title: "O\u2082 (%)",
        },
      ],
    },
    {
      title: "Cooling Gas to Cooling Zone (230)",
      width: 12,
      checkSetionTotal: true,
      fields: [
        {
          key: "cg2cz_93",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 75050,
          max: 95000,
        },
        {
          key: "c_cg2cz_0_94",
          title: "CO (%)",
        },
        {
          key: "c_cg2cz_1_94",
          title: "CO\u2082 (%)",
        },
        {
          key: "c_cg2cz_2_94",
          title: "H\u2082 (%)",
        },
        {
          key: "c_cg2cz_3_94",
          title: "H\u2082O (%)",
        },
        {
          key: "c_cg2cz_4_94",
          title: "N\u2082 (%)",
        },
        {
          key: "c_cg2cz_5_94",
          title: "CH\u2084 (%)",
        },
        {
          key: "c_cg2cz_6_94",
          title: "C\u2082H\u2086 (%)",
        },
        {
          key: "c_cg2cz_7_94",
          title: "C\u2083H\u2088 (%)",
        },
        {
          key: "c_cg2cz_8_94",
          title: "C\u2084H\u2081\u2080 (%)",
        },
        {
          key: "c_cg2cz_9_94",
          title: "C\u2085H\u2081\u2082 (%)",
        },
        {
          key: "c_cg2cz_10_94",
          title: "C\u2086H\u2081\u2084 (%)",
        },
        {
          key: "c_cg2cz_11_94",
          title: "O\u2082 (%)",
        },
      ],
    },
  ],
  ps_irons: [
    {
      title: "Pellet (914)",
      width: 6,
      fields: [
        {
          key: "gang_108",
          title: "Gangue (%)",
        },
        {
          key: "fe_total",
          title: "Fetotal",
        },
      ],
    },
    {
      title: "Product (950)",
      width: 6,
      fields: [
        {
          key: "met_109",
          title: "Metalisation (%)",
        },
        {
          key: "car_110",
          title: "Carbon (%)",
        },
      ],
    },
  ],
  thermal_recovery: [
    {
      title: "Flue out of reformer (306)",
      width: 3,
      fields: [
        {
          key: "t_flue_out_ref_111",
          title: "Temperature (°C)",
          min: 1120,
          max: 1150,
        },
      ],
    },
    {
      title: "Flue gas to stack (318)",
      width: 3,
      fields: [
        {
          key: "t_flue_to_stack_112",
          title: "Temperature (°C)",
          min: 309,
          max: 450,
        },
      ],
    },
    {
      title: "Feed gas to 2nd stage preheater (137)",
      width: 6,
      fields: [
        {
          key: "tnfeed_116",
          title: "Temperature (°C)",
          min: 307,
          max: 335,
        },
      ],
    },
    {
      title: "Feed gas to DS unit (135)",
      width: 3,
      fields: [
        {
          key: "t_feed_1_preheat_117",
          title: "Temperature (°C)",
          min: 338,
          max: 345,
        },
      ],
    },
    {
      title: "Feed gas to reformer (139)",
      width: 3,
      fields: [
        {
          key: "t_feed_2_preheat_118",
          title: "Temperature (°C)",
          min: 570,
          max: 578,
        },
      ],
    },
    {
      title: "Flue to Seal (325)",
      width: 6,
      fields: [
        {
          key: "t_flue_out_ref_111",
          title: "Temperature (°C)",
          min: 1120,
          max: 1150,
          readonly: true,
        },
        {
          key: "seal_120",
          title: "Flow Rate (Nm\u00B3/h)",
          min: 11117,
          max: 12500,
        },
      ],
    },
  ],
};

export const GROUP_FIELDS_DEFAULT_VALUE: IBalanceRequest = {
  natural_gas: {
    tng_burn_1: 25,
    png_2: 20128,
    tng_preheat_3: 342,
    main_ng_6: 0,
    aux_ng_8: 400,
    enr_9: 1991,
    ngtr_10: 1400,
    ngch_11: 800,
    c_png_0_13: 0,
    c_png_1_13: 0.35,
    c_png_2_13: 0,
    c_png_3_13: 0,
    c_png_4_13: 2.42,
    c_png_5_13: 87.1,
    c_png_6_13: 6.88,
    c_png_7_13: 2.44,
    c_png_8_13: 0.75,
    c_png_9_13: 0.15,
    c_png_10_13: 0.004,
    c_png_11_13: 0,
    cdbus_0_200: 32.43,
    cdbus_1_200: 2.45,
    cdbus_2_200: 60.13,
    cdbus_3_200: 0,
    cdbus_4_200: 1.35,
    cdbus_5_200: 3.64,
    cdbus_6_200: 0,
    cdbus_7_200: 0,
    cdbus_8_200: 0,
    cdbus_9_200: 0,
    cdbus_10_200: 0,
    cdbus_11_200: 0,
  },
  air_flows: {
    t_air_in_25: 53,
    comb_air_26: 137700,
    t_air_cold_27: 295,
    t_air_hot_29: 670,
    t_air_aux_31: 49,
    aux_air_32: 4080,
    t_dil_air_33: 40,
    dil_air_34: 0,
    wair_35: 3.79,
  },
  process_flows: {
    t_tgf_36: 38,
    tgf_37: 60259,
    p_tgf_38: 0.5,
    tpg_51: 70,
    pg_52: 98490,
    p_pg_53: 2.14,
    cd_pg_0_54: 26.11,
    cd_pg_1_54: 15.75,
    cd_pg_2_54: 53.14,
    cd_pg_3_54: 0,
    cd_pg_4_54: 1.9,
    cd_pg_5_54: 3.1,
    cd_pg_6_54: 0,
    cd_pg_7_54: 0,
    cd_pg_8_54: 0,
    cd_pg_9_54: 0,
    cd_pg_10_54: 0,
    cd_pg_11_54: 0,
    t_rg_66: 910,
    cd_rg_0_68: 33.33,
    cd_rg_1_68: 2.5,
    cd_rg_2_68: 61.68,
    cd_rg_3_68: 0,
    cd_rg_4_68: 1.29,
    cd_rg_5_68: 1.2,
    cd_rg_6_68: 0,
    cd_rg_7_68: 0,
    cd_rg_8_68: 0,
    cd_rg_9_68: 0,
    cd_rg_10_68: 0,
    cd_rg_11_68: 0,
    cgo_80: 74300,
    c_cgo_0_81: 1.87,
    c_cgo_1_81: 0.8,
    c_cgo_2_81: 23.02,
    c_cgo_3_81: 1.39,
    c_cgo_4_81: 4.42,
    c_cgo_5_81: 68.5,
    c_cgo_6_81: 0,
    c_cgo_7_81: 0,
    c_cgo_8_81: 0,
    c_cgo_9_81: 0,
    c_cgo_10_81: 0,
    c_cgo_11_81: 0,
    cg2cz_93: 75050,
    c_cg2cz_0_94: 1.76,
    c_cg2cz_1_94: 0.77,
    c_cg2cz_2_94: 21.72,
    c_cg2cz_3_94: 2.47,
    c_cg2cz_4_94: 4.28,
    c_cg2cz_5_94: 68.53,
    c_cg2cz_6_94: 0,
    c_cg2cz_7_94: 0.31,
    c_cg2cz_8_94: 0.11,
    c_cg2cz_9_94: 0.03,
    c_cg2cz_10_94: 0.01,
    c_cg2cz_11_94: 0,
    c_zrg_106: 3000,
  },
  ps_irons: {
    fe_total: 67.4518,
    gang_108: 3.56,
    met_109: 92.07,
    car_110: 1.5,
  },
  thermal_recovery: {
    t_flue_out_ref_111: 1120,
    t_flue_to_stack_112: 309,
    tnfeed_116: 307,
    t_feed_1_preheat_117: 338,
    t_feed_2_preheat_118: 570,
    seal_120: 11117,
  },
};

export const COMPOSITION_VALUES: Record<BalanceCompositionValueType, string> = {
  co: "CO (%)",
  co2: "CO\u2082 (%)",
  h2: "H\u2082 (%)",
  h2o: "H\u2082O (%)",
  n2: "N\u2082 (%)",
  ch4: "CH\u2084 (%)",
  c2h6: "C\u2082H\u2086 (%)",
  c3h8: "C\u2083H\u2088 (%)",
  c4h10: "C\u2084H\u2081\u2080 (%)",
  c5h12: "C\u2085H\u2081\u2082 (%)",
  c6h14: "C\u2086H\u2081\u2084 (%)",
  o2: "O\u2082 (%)",
  flow: "Flow Rate (Nm\u00B3/h)",
  temp: "Temperature (°C)",
};

export const COMPOSITION_KEYS: Record<BalanceCompositionKeyType, string> = {
  topGas: "Top Gas",
  tgScrubbed: "TG Scrubbed",
  reformedGas: "Reformed Gas",
  bustleGas: "Bustle Gas",
  flueGas: "Flue Gas",
  feedGasAfterPGMixer: "Feed Gas After PG Mixer",
  streamToFeedMixer: "Steam to Feed Mixer",
};

export const PRODUCT_KEYS: BalanceResultProductType[] = ["1", "2", "GC/Mass"];
